import { ENTITY_TYPES_COMMENTS } from '@constants';
import { request } from '@utils';
import { omit } from 'lodash-es';

const getTradeTickets = async (params, payload) => {
  const body = {
    body: payload,
  };

  const results = await request.post(
    `/v1/instatrade/filter?${new URLSearchParams(params)}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getTradeTicket = async (tradeTicketId) => {
  const results = await request.get(`/v1/instatrade/${tradeTicketId}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateTradeTicket = async (tradeTicketId, payload) => {
  const body = {
    body: payload,
  };
  const results = await request.patch(`/v1/instatrade/${tradeTicketId}`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getTicketTradePricing = async (tradeTicketId) => {
  const results = await request.get(`/v1/instatrade/${tradeTicketId}/pricing`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addTicketTradePricing = async (tradeTicketId, payload) => {
  const body = {
    body: payload,
  };
  const results = await request.post(
    `/v1/instatrade/${tradeTicketId}/pricing`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateTicketTradePricing = async (tradeTicketId, pricingId, payload) => {
  const params = {
    body: payload,
  };
  const results = await request.patch(
    `/v1/instatrade/${tradeTicketId}/pricing/${pricingId}`,
    params
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteTicketTradePricing = async (tradeTicketId, pricingId) => {
  const results = await request.remove(
    `/v1/instatrade/${tradeTicketId}/pricing/${pricingId}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getTicketTradeComments = async (tradeTicketId) => {
  const results = await request.get(
    `/v1/comments?entityID=${tradeTicketId}&entityType=${ENTITY_TYPES_COMMENTS.instatrade}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addTicketTradeComment = async (payload) => {
  const params = {
    body: payload,
  };
  const results = await request.post(`/v1/comments`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const editTicketTradeComment = async (commentId, comment) => {
  const params = {
    body: { comment },
  };
  const results = await request.patch(`/v1/comments/${commentId}`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteTicketTradeComment = async (commentId) => {
  const results = await request.remove(`/v1/comments/${commentId}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getTicketTradeFiles = async (tradeTicketId) => {
  const results = await request.get(`/v1/instatrade/${tradeTicketId}/files`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const uploadTicketTradeFile = async (
  tradeTicketId,
  files,
  documentType = 0, // video(VehicleVideo) = 56 ή  gia to document(CarLicense) = 0
  tags = []
) => {
  const fd = new FormData();
  fd.append('files', files);
  fd.append('type', documentType);
  if (tags?.length) {
    tags?.forEach((element) => {
      fd.append('tags', element);
    });
  }

  const body = {
    body: fd,
    header: {
      Accept: '*/*',
    },
  };
  const results = await request.post(
    `/v1/instatrade/${tradeTicketId}/files`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteTradeTicketFile = async (tradeTicketId, docId) => {
  const results = await request.remove(
    `/v1/instatrade/${tradeTicketId}/files/${docId}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getTicketTradeChangeLog = async (tradeTicketId) => {
  const results = await request.get(
    `/v1/changelogs?entityID=${tradeTicketId}&orderBy=createdAt&order=desc`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const postFiles = async (tradeId, body) => {
  const lang = localStorage?.getItem('lang') || 'el';

  const payload = {
    body,
  };
  const results = await request.post(
    `/v1/instatrade/${tradeId}/files?lang=${lang}`,
    payload
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const uploadFilesToS3 = async (url, file, contentType) => {
  const results = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': contentType,
    },
    body: file,
  });
  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const validateFiles = async (tradeId, fileId) => {
  const lang = localStorage?.getItem('lang') || 'el';

  const payload = {
    body: {},
  };
  const results = await request.post(
    `/v1/instatrade/${tradeId}/files/${fileId}/validate?lang=${lang}`,
    payload
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const exportFileAsync = async ({ params, rule }) => {
  const cleanParams = omit(params, ['page', 'pageSize']);

  const body = {
    body: { type: 'csv', rule },
  };

  const results = await request.post(
    `/v1/instatrade/export?${new URLSearchParams({
      ...cleanParams,
    })}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateTradeTicketBooking = async ({ tradeTicketId, payload }) => {
  const body = {
    body: payload,
  };
  const results = await request.patch(
    `/v1/instatrade/${tradeTicketId}/booking`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const sendTradeTicketOffer = async (payload) => {
  const params = {
    body: payload,
  };
  const results = await request.post(`/v1/instatrade/email`, params);
  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addTradeTicketBooking = async ({ tradeTicketId, payload }) => {
  const body = {
    body: payload,
  };
  const results = await request.post(
    `/v1/instatrade/${tradeTicketId}/booking`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const sendEmails = async (id, payload) => {
  const params = {
    body: payload,
  };

  const results = await request.post(
    `/v1/instatrade/${id}/dealers/email`,
    params
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

export {
  getTradeTickets,
  getTradeTicket,
  updateTradeTicket,
  getTicketTradeComments,
  addTicketTradeComment,
  editTicketTradeComment,
  deleteTicketTradeComment,
  getTicketTradeFiles,
  uploadTicketTradeFile,
  deleteTradeTicketFile,
  getTicketTradePricing,
  updateTicketTradePricing,
  addTicketTradePricing,
  deleteTicketTradePricing,
  getTicketTradeChangeLog,
  postFiles,
  uploadFilesToS3,
  validateFiles,
  exportFileAsync,
  sendTradeTicketOffer,
  sendEmails,
  updateTradeTicketBooking,
  addTradeTicketBooking,
};
